// @spec BCP-STR-041
import { createFileRoute } from '@tanstack/react-router';

import { ExerciseSummaryReport } from '@/features/bcp/components/ExerciseSummaryReport';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/reports/exercise-summary')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.exerciseSummaryReport'),
  }),
  component: ExerciseSummaryReportPage,
});

function ExerciseSummaryReportPage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <ExerciseSummaryReport />
      </div>
    </div>
  );
}
